export default __webpack_public_path__ + "static/media/zihan.c88b2e2a.jpg";